import { RouteRecordRaw } from 'vue-router'

const UserManagerRouter: Array<RouteRecordRaw> = [
  {
    path: '/KiliMall/settleAccounts/brokerageImport',
    name: 'BrokerageImport',
    component: () => import(/* webpackChunkName: "settleAccounts" */'@/views/Kilimall/manage/settleAccounts/brokerageImport.vue')
  },
]
export default UserManagerRouter
